<template>
    <div class="wrapper-form-block-socio-contato" :inert="pPreview">
        <p><strong>Quais as informações de contato?</strong></p>
        <br/>
        <div class="columns is-multiline">
            <div class="column is-6">
                <TrfEmailInput
                label="E-mail"
                placeholder="E-mail de contato"
                margin="0"
                id="form-block-socio-email-contato"
                v-model="formData.emailContato"
                maxLength="100"
                ref="BlockSocioEmailContato"
                v-e2e="'block-email-socio'"
                :required="required && dirtyState.emailContato"
                @update:model-value="setEmailContato"
                ></TrfEmailInput>
            </div>
            <div class="column is-6">
                <TrfPhoneInput
                label="WhatsAPP"
                placeholder="WhatsAPP de contato"
                margin="0"
                id="form-block-socio-whatsapp-contato"
                v-model="formData.whatsappContato"
                maxLength="15"
                ref="BlockSocioWhatsappContato"
                v-e2e="'block-whatsapp-socio'"
                :required="required && dirtyState.whatsappContato"
                @update:model-value="setWhatsappContato"
                ></TrfPhoneInput>
            </div>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoSocioContato',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfEmailInput: defineAsyncComponent(() => import('../../Input/TrfEmailInput.vue')),
        TrfPhoneInput: defineAsyncComponent(() => import('../../Input/TrfPhoneInput.vue'))
    },
    props: {
        pEmailContato: {
            type: String,
            default: ''
        },
        pWhatsappContato: {
            type: String,
            default: ''
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: null
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        formData: {
            emailContato: this.pEmailContato,
            whatsappContato: this.pWhatsappContato
        },
        dirtyState: {
            emailContato: false,
            whatsappContato: false
        }
      };
    },
    computed: {
      emailInternalValidation() {
          return this.formData.emailContato && this.$refs.BlockSocioEmailContato.verificarSeInputEValido()
      },
      whatsappInternalValidation() {
          return this.formData.whatsappContato && this.$refs.BlockSocioWhatsappContato.verificarSeInputEValido()
      },
      isDirty: {
        get() {
          return this.dirtyState.emailContato && this.dirtyState.whatsappContato;
        },
        set(valor) {
          for(let campo in this.dirtyState) {
            this.dirtyState[campo] = valor
          }
        }
      },
      isEmailInvalido() {
            if (!this.required) return false;
            return this.dirtyState.emailContato && (!this.formData.emailContato || !this.emailInternalValidation)
      },
      markupErrorEmail() {
          return !this.pPreview && this.isEmailInvalido
      },
      isWhatsappInvalido() {
            if (!this.required) return false;
            return this.dirtyState.whatsappContato && (!this.formData.whatsappContato || !this.whatsappInternalValidation)
      },
      markupErrorWhatsapp() {
          return !this.pPreview && this.isWhatsappInvalido
      },
      isInvalida() {
        return this.isEmailInvalido && this.isWhatsappInvalido
      }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
                if(this.required && this.$refs.BlockSocioEmailContato) {
                    this.$refs.BlockSocioEmailContato.verificarSeInputEstaVazio(false)
                }
                if(this.required && this.$refs.BlockSocioWhatsappContato) {
                    this.$refs.BlockSocioWhatsappContato.verificarSeInputEstaVazio(false)
                }
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        },
        pSocioEmPreenchimento: {
          immediate: true,
            handler(novo) {
                if (!novo) return;
                this.formData.emailContato = novo.socio.emailContato;
                this.formData.whatsappContato = novo.socio.whatsappContato;
            },
            deep: true
        }
    },
    methods: {
        setEmailContato(emailContato) {
            this.formData.emailContato = emailContato? emailContato : ''; //garante tipo
            this.emitFormData(this.formData)
            this.dirtyState.emailContato = true;
        },
        setWhatsappContato(whatsappContato) {
            this.formData.whatsappContato = whatsappContato? whatsappContato : ''; //garante tipo
            this.emitFormData(this.formData)
            this.dirtyState.whatsappContato = true;
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        }
    }
  };
  </script>
  